import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import arrow from "../../assets/icons/arrow_down.svg";
import nft_placeholder from "../../assets/placeholder/placeholder_large.svg";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { MOBILE } from "../../constants/breakpoints";

const ImageSection = ({ nftMetadata }: { nftMetadata: any }) => {
  const [nftData, setNftData] = useState<any>({});
  const [showFullDescription, setShowFullDescription] = useState(false);

  const wallet = useSelector((state: RootState) => state.walletState);
  const navigate = useNavigate();

  useEffect(() => {
    if (nftMetadata && nftMetadata.metadata) {      
      setNftData(JSON.parse(nftMetadata.metadata));
    }
  }, [nftMetadata]);

  const handleBackClick = () => {
    navigate(`/proxy-tokens-list`);
  };

  return (
    <>
      {nftData && nftData.description ? (
        <div>
          <span
            css={css`
              display: flex;
              cursor: pointer;
              transition: all 0.2s ease-in-out;
            `}
            onClick={handleBackClick}
          >
            <img
              css={css`
                transform: rotate(90deg);
                filter: brightness(-100%);
              `}
              src={arrow}
              alt=""
            />
            <p
              css={css`
                margin-left: 13.5px;
                font-weight: 700;
                font-size: 16px;
              `}
            >
              List of Proxy Tokens
            </p>
          </span>
          <div css={css`
              display: flex;
              align-items: start;
              flex-direction: column;
              @media (max-width: ${MOBILE}px) {
                flex-direction: row;
              }
            `}>
            <div>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
              >
                <h1>{nftData.name} </h1>
              </div>
              <h4
                css={css`
                  font-weight: 500;
                  font-size: 16px;
                  margin: 0;
                  margin-top: 5px;
                  max-width: 350px;
                `}
              >
                {showFullDescription
                  ? nftData.description
                  : nftData.description.slice(0, 40)}
                <span
                  css={css`
                    color: #757272;
                    cursor: pointer;
                  `}
                  onClick={() => setShowFullDescription(!showFullDescription)}
                >
                  {showFullDescription ? " View Less" : " View More"}
                </span>
              </h4>
            </div>

            <img
              css={css`
                width: 580px;
                object-fit: cover;
                border: 1px solid #ccc4b3;
                border-radius: 24px;
                margin-top: 40px;
                @media (max-width: ${MOBILE}px) {
                  width: 106px;
                  height: 135.497px;
                }
              `}
              src={nftData.image ? nftData.image : nft_placeholder}
              alt=""
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ImageSection;
